module.exports = __webpack_public_path__ + "static/img/lshy01.74bfdab.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/lshy01.png
// module id = O76j
// module chunks = 1